/* Dusky Rose - true hover zoom for PDP media.
 *
 * Dawn's "Magnify on hover" is misleadingly named: enableZoomOnHover() in
 * magnify.js binds image.onclick, so the magnifier only STARTS on click
 * (then follows the cursor and tears down on mouseleave). This rebinds the
 * same magnifier to mouseenter so zoom engages the moment the cursor is over
 * the image - the behavior the name promises.
 *
 * Reuses Dawn's own globals (magnify, moveWithHover) rather than forking the
 * implementation; only the trigger changes. Applies only on precise-pointer
 * devices - touch keeps Dawn's default tap behavior.
 */
(function () {
  'use strict';

  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var tries = 0;
  function arm() {
    if (typeof window.magnify !== 'function' || typeof window.moveWithHover !== 'function') {
      if (tries++ < 25) setTimeout(arm, 200); // magnify.js is deferred and may load after us
      return;
    }
    document.querySelectorAll('.image-magnify-hover').forEach(function (image) {
      image.onclick = null;
      image.onmouseenter = function (event) {
        // don't stack overlays if one is already live for this image
        if (image.parentElement.querySelector('.image-magnify-full-size')) return;
        window.magnify(image, 2);
        window.moveWithHover(image, event, 2);
      };
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arm);
  } else {
    arm();
  }
})();
